<template>
  <v-item-group class="pb-7">
    <v-row class="pb-9">
      <v-col
        v-for="(item, key) of list"
        :key="key"
        cols="12"
        sm="5"
        md="3"
        class="pr-5 pb-5 d-flex justify-center justify-sm-start"
      >
        <QuotationCard
          @click="selectedItem(item)"
          :name="item.nome"
          :background="item.imagem"
          :value="item.valor"
          :class="{ 'base-card-active': findActiveItem(item) }"
        />
      </v-col>
    </v-row>
  </v-item-group>
</template>
<script>
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";

export default {
  components: {
    QuotationCard: CardDescriptionButton
  },
  methods: {
    selectedItem(item) {
      this.$emit("resource", item);
    },
    findActiveItem(item) {
      return this.model ? item.id === this.model.id : false;
    }
  },
  props: {
    model: {
      type: Object
    },
    list: {
      type: Array
    }
  }
};
</script>
<style lang="sass" scoped></style>
